import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { debouncedLoadData } from 'src/utils/utils'
import { Button, Icon, Menu, Popover } from '@softwaredev_cegeka/stix-core'
import EntityTable from './EntityTable'
import './entityTable.scss'

function ServiceActionsTableContextMenu({
    canEdit,
    canDelete,
    onDeleteClick,
    editLink,
}) {
    if (canEdit && canDelete) {
        return (
            <Menu.Option
                contextMenu={[
                    {
                        as: () => (
                            <Link className="stix-dropdown-item" to={editLink}>
                                <Icon icon="edit" title="Edit service action" />
                            </Link>
                        ),
                    },
                    {
                        as: () => (
                            <Popover
                                rootClose={true}
                                placement="left"
                                trigger="click"
                                content={
                                    <div className="modal-wrapper">
                                        <div>
                                            Are you sure you want to delete this
                                            service action?
                                        </div>
                                        <div className="button-modal-wrapper">
                                            <Button
                                                variant={'outline-danger'}
                                                onClick={onDeleteClick}
                                            >
                                                Confirm
                                            </Button>
                                        </div>
                                    </div>
                                }
                            >
                                <button
                                    className="stix-dropdown-item custom-dropdown-item"
                                    onClick={e => e.preventDefault()}
                                >
                                    <Icon icon="delete" />
                                    <span>Remove</span>
                                </button>
                            </Popover>
                        ),
                    },
                ]}
                icon={'actions-vert'}
            />
        )
    } else if (canEdit) {
        return (
            <Link to={editLink}>
                <span className="sr-only">edit</span>
                <Icon icon="edit" />
            </Link>
        )
    } else if (canDelete) {
        return (
            <Popover
                rootClose={true}
                placement="left"
                trigger="click"
                content={
                    <div className="modal-wrapper">
                        <div>
                            Are you sure you want to delete this service action?
                        </div>
                        <div className="button-modal-wrapper">
                            <Button
                                variant={'outline-danger'}
                                onClick={onDeleteClick}
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                }
            >
                <Button className="table-action-button" variant="naked">
                    <span className="sr-only">remove</span>
                    <Icon icon="delete" />
                </Button>
            </Popover>
        )
    }
    return ''
}

function ServiceActionsTable({
    data,
    loading,
    params,
    setParams,
    deleteAction,
    history,
    match,
    displayNamespace,
    canDelete = true,
    canEdit = true,
}) {
    const columns = [
        {
            Header: 'Category',
            accessor: 'category',
        },
        {
            Header: 'Key',
            accessor: 'key',
        },
        {
            Header: 'Description',
            accessor: 'description',
            width: '40%',
        },
        {
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => {
                return (
                    <ServiceActionsTableContextMenu
                        selectedRow={selectedRow}
                        canDelete={canDelete}
                        canEdit={canEdit}
                        onDeleteClick={() => {
                            deleteAction(selectedRow.row.original.id)
                        }}
                        editLink={`/service-form/${match.params.id}/service-action/${selectedRow.row.original.id}`}
                    />
                )
            },
            width: '3%',
        },
    ]
    // if any column that is a relationship and not a direct property to the service action object
    // gets added here, it shouldn't be passed in the handleGlobalFilter function
    const columnsToFilter = [
        {
            column: 'category',
        },
        {
            column: 'key',
        },
        {
            column: 'description',
        },
    ]

    if (displayNamespace) {
        columns.unshift({
            Header: 'Namespace',
            filterPlaceholder: 'Search namespace...',
            accessor: 'service_namespace',
            Cell: ({ cell }) => {
                return cell.value ? cell.value : ''
            },
        })
        columnsToFilter.unshift({
            column: 'service_namespace',
            label: 'namespace',
        })
    }

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                if (key === 'service_namespace') {
                    params['namespace_like'] = value.toString()
                } else {
                    params[key + '_like'] = value.toString()
                }
            })
        })

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        columnsToFilter.forEach(col => {
            params[col.column + '_like'] = value.toString()
        })
        params.use_or = true
        debouncedLoadData(params, setParams)
    }

    return (
        <EntityTable
            loading={loading}
            data={data}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
            className="service-actions-table"
        />
    )
}

export default withRouter(ServiceActionsTable)
